import { createUserFileUpload, fetchApi } from './UserApi';
import { Photo } from '../Hooks/UsePhotos';

export default class PhotoService {
	public static async getPhotos(hash: string) {
		const response = await fetchApi<{ photos: Photo[] }>({
			route: 'photos/api',
			data: {
				hash,
				action: 'getPhotos',
			},
			errorMessage: 'Error loading photos',
		});
		return response.data.photos;
	}

	public static async deletePhoto(hash: string, photoId: number) {
		await fetchApi({
			route: 'photos/api',
			data: {
				hash,
				action: 'deletePhoto',
				photoId,
			},
			errorMessage: 'Error deleting photo',
		});
	}

	public static async deleteMultiplePhotos(hash: string, photoIds: number[]) {
		const response = await fetchApi<{ deletedCount: number; message: string }>({
			route: 'photos/api',
			data: {
				hash,
				action: 'deleteMultiplePhotos',
				photoIds,
			},
			errorMessage: 'Error deleting photos',
		});
		return response.data;
	}

	public static async uploadPhoto(hash: string, file: File) {
		const upload = createUserFileUpload(hash);
		const formData = new FormData();
		formData.append('file', file);

		const response = await upload<{ photo: Photo; message: string }>({
			route: `photos/upload/${hash}`,
			data: formData,
			errorMessage: 'Error uploading photo',
		});

		return response.data;
	}
}
